import { gql } from "@apollo/client";

export const ADD_OR_UPDATE_SIZE_AND_WEIGHT_IN_INCIDENT = gql`
  mutation addOrUpdateSizeAndWeightInIncident(
    $input: AddOrUpdateSizeAndWeightInIncidentInput!
  ) {
    addOrUpdateSizeAndWeightInIncident(input: $input) {
      errors
      clientMutationId
      incidentUuid
      sizeAndWeight {
        axleGroups {
          id
          name
          weight
          overLimit
          leftSubtotal
          rightSubtotal
          subtotal
          axles {
            id
            name
            leftAxleWeight
            rightAxleWeight
            totalAxleWeight
          }
          axleGroupType {
            id
            name
            weightLimit
          }
          axleGroupLimit
        }
        axleLimitWeight
        carrier {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            dob
            cell
            organization
            driversLicense
            licenseState {
              id
              name
            }
            phone
            mailingAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                expireAt
                id
                notes
              }
              zip
            }
            homeAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
              }
              zip
            }
          }
        }
        carrierAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
          }
          zip
        }
        carrierPhone
        cmvsChecked
        commodities {
          id
          name
          position
          oriId
        }
        courtAction
        cvsaDecalsIssued
        dimensionViolationIdentified
        driverViolations
        endedAt
        enforcementActivity {
          id
          name
          position
          oriId
        }
        escreen
        fineTotal
        grossWeight
        height
        id
        incident {
          id
          incidentNumber
        }
        innerDimension
        issuedTo {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            dob
          }
        }
        length
        location {
          city
          id
          intersection
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            id
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        locked
        lv1HazmatInspections
        lv1Inspections
        lv2HazmatInspections
        lv2Inspections
        lv3HazmatInspections
        lv3Inspections
        lv4HazmatInspections
        lv4Inspections
        lv5HazmatInspections
        lv5Inspections
        lv6Inspections
        lv7Inspections
        lv8Inspections
        numberArrests
        numberOosDrivers
        numberOosVehicles
        numberVcvcsIssued
        offloadRedistribution
        operator {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            dob
            cell
            organization
            driversLicense
            licenseState {
              id
              name
            }
            phone
            mailingAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                id
                notes
              }
              zip
            }
            homeAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                id
                notes
              }
              zip
            }
          }
        }
        operatorAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
          }
          zip
        }
        operatorPhone
        otherWeighsCount
        outerDimension
        owner {
          id
          personalAttribute {
            id
            lastName
            firstName
            middleName
            dob
            cell
            organization
            driversLicense
            licenseState {
              id
              name
            }
            phone
            mailingAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                id
                notes
              }
              zip
            }
            homeAddress {
              city
              id
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              uuid
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                createdAt
                officer {
                  deptAttribute {
                    id
                    badge
                    ori {
                      id
                      abbreviation
                    }
                  }
                  personalAttribute {
                    id
                    firstName
                    lastName
                  }
                }
                id
                notes
              }
              zip
            }
          }
        }
        ownerAddress {
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          uuid
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
            id
            notes
          }
          zip
        }
        ownerPhone
        permitNumberFiled
        platformOverUnder
        platformWeigh
        platformWeighsCount
        portableWeighsCount
        powerUnit {
          id
          year
          axles {
            id
            name
          }
          vehicleState {
            id
            name
          }
          vehicleMake {
            id
            nhtsaId
            name
          }
          vehicleModel {
            id
            nhtsaId
            name
          }
          vehiclePlate {
            id
            name
          }
        }
        printCarrier
        printOwner
        registeredWeight
        roadLimitOverUnder
        roadLimitWeight
        roadType {
          id
          name
          position
          oriId
        }
        scales {
          id
          name
          scaleMake {
            id
            name
          }
          scaleModel {
            id
            name
          }
          serialNumber
        }
        semiPortableWeighsCount
        sizePermitsChecked
        startedAt
        stateHighway {
          id
          name
          position
          oriId
          roadType {
            id
            name
            oriId
          }
        }
        steerAxleLimit
        steerAxleTireSize
        supervisedInspections
        trailers {
          id
          year
          vehicleState {
            id
            name
          }
          vehicleMake {
            id
            nhtsaId
            name
          }
          vehicleModel {
            id
            nhtsaId
            name
          }
          vehiclePlate {
            id
            name
          }
        }
        triaxleDimension
        vehicleViolations
        violationIdentified
        width
        weightMethods {
          id
          name
          position
          oriId
        }
        weightPermitsChecked
        wimsWeighsCount
      }
    }
  }
`;
